//@flow
import {
  endpoints,
  createScheduleMessageApi,
  deleteScheduleMessageApi,
  editScheduleMessageApi,
  listScheduledMessagesApi,
} from './api';

import type {
  CreateScheduleMessageRequest,
  EditScheduleMessageRequest,
  ListScheduleMessageRequest,
  PaginationResponse,
  ScheduleMessage,
} from '../../../entities';
import {buildRoute} from '../../../http';

export function createScheduleMessageService(
  conversationId: string,
  request: CreateScheduleMessageRequest
): Promise<ScheduleMessage> {
  const route = buildRoute(endpoints.CREATE_SCHEDULED_MESSAGE, [
    conversationId,
  ]);
  return createScheduleMessageApi(request, {
    route,
  }).toPromise();
}

export function editScheduleMessageService(
  messageId: string,
  request: EditScheduleMessageRequest
): Promise<ScheduleMessage> {
  const route = buildRoute(endpoints.EDIT_SCHEDULED_MESSAGE, [messageId]);
  return editScheduleMessageApi(request, {
    route,
  }).toPromise();
}

export function deleteScheduleMessageService(messageId: string): Promise<void> {
  const route = buildRoute(endpoints.DELETE_SCHEDULED_MESSAGE, [messageId]);
  return deleteScheduleMessageApi({route}).toPromise();
}

const defaultPagination = {
  page: 0,
  size: 10,
};
export function listScheduledMessagesService(
  params: ListScheduleMessageRequest = defaultPagination
): Promise<PaginationResponse<ScheduleMessage>> {
  const {page, size} = params;
  const searchParams: any = {
    page,
    size,
  };

  if (params.states) {
    searchParams.states = params.states.join(',');
  }
  if (params.crmConversationId) {
    searchParams.crm_conversation_id = params.crmConversationId;
  }
  return listScheduledMessagesApi(searchParams).toPromise();
}
